import '@vebox/etui-system';
import '../utilities/responsive.js';
import { createElement } from 'react';
import '../_rollupPluginBabelHelpers-3b7bd988.js';
import 'react-modal';
import { M as Modal } from '../Modal-5d30452a.js';

function ModalBase({
  isOpen,
  onClose,
  animationTiming = 0,
  fullPageSize,
  appElement,
  children
}) {
  return /*#__PURE__*/createElement(Modal, {
    isOpen: isOpen,
    onRequestClose: onClose,
    animationTiming: animationTiming,
    fullPageSize: fullPageSize,
    appElement: appElement
  }, children);
}

export default ModalBase;
